import React from 'react';
import { Box } from '@mui/material';
import './MenuThumbnails.css'; // Si aún deseas usar CSS personalizado

const MenuThumbnails = ({ images, onClick }) => {
  if (!images || images.length === 0) {
    return <p>No images available</p>;
  }

  return (
    <Box className='container-thumb' sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
      {images.map((image, index) => (
        image.UrlMin && (
          <img
            key={index}
            src={image.UrlMin}
            alt={`Thumbnail for ${image.description || `image ${index + 1}`}`} 
            className='img-thumb' 
            onClick={() => onClick(image)}  // Cambié (e) por solo pasar la imagen
            style={{ cursor: 'pointer', maxWidth: '150px', borderRadius: '5px' }} // Estilo mejorado para las miniaturas
          />
        )
      ))}
    </Box>
  );
};

export default MenuThumbnails;
